import type { ChatMessage } from '../../api/conversations';

function normalizeId(raw: unknown): string | undefined {
  if (typeof raw === 'string' && raw.trim()) return raw.trim();
  if (typeof raw === 'number' && Number.isFinite(raw)) return String(raw);
  return undefined;
}

export function offerUuidFromMessage(
  message: Pick<ChatMessage, 'card_payload'>,
): string | undefined {
  const payload = message.card_payload;
  if (!payload || typeof payload !== 'object') return undefined;
  const direct = normalizeId(
    payload.offer_uuid ?? payload.offerUuid ?? payload.offer_id ?? payload.offerId,
  );
  if (direct) return direct;
  const nested = payload.offer;
  if (nested && typeof nested === 'object') {
    const fromObject = normalizeId(
      (nested as Record<string, unknown>).uuid ?? (nested as Record<string, unknown>).id,
    );
    if (fromObject) return fromObject;
  } else {
    const fromValue = normalizeId(nested);
    if (fromValue) return fromValue;
  }
  return normalizeId(payload.uuid);
}

export function isOfferCardMessage(message: Pick<ChatMessage, 'card_type'>): boolean {
  return typeof message.card_type === 'string' && message.card_type.toLowerCase().includes('offer');
}
